import { ComponentProps } from 'react';
import { ButtonWithoutSuir } from './ButtonWithoutSuir';

export interface ButtonProps extends ComponentProps<typeof ButtonWithoutSuir> {
  isMobile: boolean;
  isHoveredIcon: boolean;
}
export const Button = (props: any) => <ButtonWithoutSuir {...props} />;
